import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Select from "react-select";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../utils/IDS";
import {
  GetSingle,
  Update,
  Create,
} from "../../../../features/admin/user-management/user/Slice";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import { useForm } from "react-hook-form";
import { GetAll } from "../../../../features/admin/role-management/role/Slice";
import PasswordChecklist from "react-password-checklist";
import Successfull_Modal from "../../../common-components/common_Modal/Successfull_Modal/Successfull_Modal";

const Add = ({ id, setId, setShowError, setSuccess, setErr }) => {
  const { fetch } = IndexUse();
  const dispatch = useDispatch();

  const roles = useSelector((state) => state.rolemanagement.roles);

  const [password, setPassword] = useState("");

  console.log(roles, "roles");
    const [modalShow, setModalShow] = React.useState(false);

  const {
    register,
    handleSubmit,
    clearErrors,
    setValue,
    getValues,
    setError,
    control,
    watch,
    formState: { errors },
    reset,
    image_required = true,
  } = useForm();

  const confirmPassword = watch("confirm_password");
  const imageFile = watch("image");


  const GetData = async (id) => {
      try {
        const res = await dispatch(GetSingle(id));
        if (res.meta.requestStatus === "fulfilled") {
          reset(res?.payload?.data);
        }
      } catch (error) {
        console.error(error);
      }
    };
    useEffect(() => {
      window.scrollTo(0, 0);
      if (id !== "") {
        GetData(id);
      }
    }, [id]);


  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("first_name", data?.first_name);
      sendData.append("last_name", data?.last_name);
      sendData.append("email", data?.email);
      sendData.append("contact_no", data?.contact_no);
      sendData.append("role_id", data?.role_id);
      sendData.append("password", data?.password);
      // sendData.append("message", data?.message);
      // sendData.append("description", data?.description);
      // sendData.append("image", data?.image[0]);
      let response;
      if (id) {
        response = await dispatch(Update({ id: id, data: sendData }));
      } else {
        response = await dispatch(Create(sendData));
      }
      if (response.meta.requestStatus === "fulfilled") {
        await fetch();
        await setId("");
        setModalShow(true);
        reset();
        

        setTimeout(() => {
          setModalShow(false);
        }, 3000);
      } else if (response.meta?.requestStatus === "rejected") {
        setShowError(response.payload?.response?.data?.errors);
      }

      if (response.payload == 406) {
        await setError("contact_no", {
          type: "manual",
          message: "Contact Number Already Exists",
        });
      }
      if (response.payload == 405) {
        await setError("email", {
          type: "manual",
          message: "Email Already Exists",
        });
      }
    } catch (error) {
      console.error("error in Add Namee", error);
    }
  };

  const getRoles = async () => {
    const res = await dispatch(GetAll());
  };

  useEffect(() => {
    getRoles();
  }, [dispatch]);

  return (
    <>
      <div className="forms_section">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <div className="col-lg-6 col-md-6 mb-3">
              <Form.Group className="mb-3" controlId="formBasicName">
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  type="text"
                  name=""
                  placeholder="First Name"
                  {...register("first_name", {
                    required: "first_name is Required",
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.name,
                  })}
                />
                {errors.first_name && (
                  <span className="text-danger">
                    {errors.first_name?.message}
                  </span>
                )}
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBasicName">
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  type="text"
                  name=""
                  placeholder="Last Name"
                  {...register("last_name", {
                    required: "last_name is Required",
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.name,
                  })}
                />
                {errors.last_name && (
                  <span className="text-danger">
                    {errors.last_name?.message}
                  </span>
                )}
              </Form.Group>
            </div>
            <div className="col-lg-6 col-md-6 mb-3">
              <Form.Group className="mb-3" controlId="formBasicName">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Email"
                  className={classNames("", { "is-invalid": errors?.email })}
                  {...register("email", {
                    required: "email is required",
                    maxLength: {
                      value: 100,
                      message: "email cannot exceed 100 characters",
                    },
                  })}
                />
                {errors?.email && (
                  <Form.Text className="text-danger">
                    {errors?.email?.message}
                  </Form.Text>
                )}
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBasicName">
                <Form.Label>Contact No</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Subject"
                  className={classNames("", {
                    "is-invalid": errors?.contact_no,
                  })}
                  {...register("contact_no", {
                    required: "contact_no is required",
                    maxLength: {
                      value: 100,
                      message: "contact_no cannot exceed 100 characters",
                    },
                  })}
                />
                {errors?.contact_no && (
                  <Form.Text className="text-danger">
                    {errors?.contact_no?.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>
            {roles?.data?.data && roles?.data?.data.length > 0 && (
              <div className="col-lg-6 col-md-6 mb-3">
                <Form.Group className="mb-3" controlId="formBasicRole">
                  <Form.Label>Role</Form.Label>
                  <Form.Select
                    {...register("role_id", {
                      required: "Role is required",
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.role_id,
                    })}
                  >
                    <option value="">Select Role</option>
                    {roles.data.data.map((role) => (
                      <option key={role.id} value={role.id}>
                        {role.name}
                      </option>
                    ))}
                  </Form.Select>

                  {errors.role_id && (
                    <span className="text-danger">
                      {errors.role_id?.message}
                    </span>
                  )}
                </Form.Group>
              </div>
            )}
            <div className="col-lg-6 col-md-6 mb-3">
              {/* Password */}
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Password"
                  className={classNames("", { "is-invalid": errors?.password })}
                  {...register("password", {
                    required: "Password is required",
                    minLength: {
                      value: 8,
                      message: "Password must be at least 8 characters",
                    },
                  })}
                  onChange={(e) => setPassword(e.target.value)}
                />
                {errors?.password && (
                  <Form.Text className="text-danger">
                    {errors.password.message}
                  </Form.Text>
                )}
              </Form.Group>

              {/* Confirm Password */}
              <Form.Group className="mb-3" controlId="formBasicConfirmPassword">
                <Form.Label>Confirm Password</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Confirm Password"
                  className={classNames("", {
                    "is-invalid": errors?.confirm_password,
                  })}
                  {...register("confirm_password", {
                    required: "Confirm Password is required",
                    validate: (value) =>
                      value === password || "Passwords do not match",
                  })}
                />
                {errors?.confirm_password && (
                  <Form.Text className="text-danger">
                    {errors.confirm_password.message}
                  </Form.Text>
                )}
              </Form.Group>

              {/* Password Checklist */}
              <PasswordChecklist
                rules={["minLength", "number", "capital", "special", "match"]}
                minLength={8}
                value={password}
                valueAgain={confirmPassword}
                onChange={(isValid) => console.log("Password valid:", isValid)}
              />
            </div>
          </div>

          <div className="form_submit_div ">
            <div className="row">
              <div className="col-lg-4 mx-auto mb-3">
                <div className="button_group">
                  <button
                    type="button"
                    className="closebtn theme_bg"
                    onClick={() => {
                      reset({ name: "" });
                      setId("");
                    }}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="addbtn"
                    onClick={handleSubmit(onSubmit)}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>

      <Successfull_Modal
        message={"Successful"}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default Add;
